import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { resetAction } from '../actions/resetAction';
import { StatisticsState } from '../storeTypes';
import { ActivityStatisticsDto } from '../../types/statistics';

const initialState: StatisticsState = {};

const statisticsSlice = createSlice({
  name: 'statisticsSlice',
  initialState,
  extraReducers: (builder) => builder.addCase(resetAction, () => initialState),
  reducers: {
    setActivityStatisticsAction: (
      draftState: StatisticsState,
      action: PayloadAction<{ activityStatistics: ActivityStatisticsDto }>,
    ) => {
      draftState.activityStatistics = action.payload.activityStatistics;
    },
  },
});

export const { setActivityStatisticsAction } = statisticsSlice.actions;

export default statisticsSlice;
